import React from 'react';

import Right from "./Right";
import Panel from "./Panel";
import FormItem from "./FormItem";
import CoolLoader2 from "./CoolLoader2";

import {api, parsePHPtime} from "./baseFunctions";
import {Link} from "react-router";
import {history} from "../store";

import langs from "./langs/phpIndex";
class UserInfoPage extends React.Component {
	constructor(){
		super();
		this.getData = this.getData.bind(this);
		this.save = this.save.bind(this);
		this.state = {
			data: false,

			obs: false,

			ra: false,
			raSheets: false,
			userData: false
		};
	}
	componentDidMount(){
		api("POST", {"type": "getUsers"}, (d) => {
      if(!d.error)
      {
      	this.setState({
      		userData: d.data.find((d) => d.id === this.props.params.id)
      	});
      }
    }, this.props.auth, 1);

    api("POST", {"type": "getRAs", "uID": this.props.params.id}, (d) => {
    	if(!d.error)
      {
      	this.setState({
      		ra: d.data,
      		//raSheets: d.sheets
      	});
      	requestAnimationFrame(() => {
					window.overViewTable = window.$("#ras").dataTable({
	            "iDisplayLength": 10,
	            "order": [[ 0, "desc" ]],
	            "language": {
	                "lengthMenu": "Vis _MENU_ pr side",
	                "zeroRecords": "Intet fundet",
	                "info": "Side _PAGE_ / _PAGES_",
	                "infoEmpty": "Intet indhold",
	                "search":         "Søg: ",
	                 "paginate": {
	                    "first":      "Første",
	                    "last":       "Sidste",
	                    "next":       "Næste",
	                    "previous":   "Forrige"
	                },
	                "infoFiltered": "(filterer fra _MAX_ colonner)"
	            }
	        });
      	});
      }
    }, this.props.auth, 1);

    api("POST", {"type": "getOBSs", "uID": this.props.params.id}, (d) => {
    	if(!d.error)
      {
      	this.setState({
      		obs: d.data
      	});
      	requestAnimationFrame(() => {
					window.overViewTable2 = window.$("#obs").dataTable({
	            "iDisplayLength": 10,
	            "order": [[ 0, "desc" ]],
	            "language": {
	                "lengthMenu": "Vis _MENU_ pr side",
	                "zeroRecords": "Intet fundet",
	                "info": "Side _PAGE_ / _PAGES_",
	                "infoEmpty": "Intet indhold",
	                "search":         "Søg: ",
	                 "paginate": {
	                    "first":      "Første",
	                    "last":       "Sidste",
	                    "next":       "Næste",
	                    "previous":   "Forrige"
	                },
	                "infoFiltered": "(filterer fra _MAX_ colonner)"
	            }
	        });
      	});
      }
    }, this.props.auth, 1);
	}
	save(e)
	{
		const IS_EDIT = this.props.params.id && this.props.params.id !== "new" && this.state.data[Number(this.props.params.id)] ? this.state.data[Number(this.props.params.id)] : false;
		e.preventDefault();
		const FORM = {};
		Object.keys(this.refs).map((d) => FORM[d] = this.refs[d].value);
		if(IS_EDIT)
		{
			FORM.id = IS_EDIT.id;
		}
		api("POST", {"type": IS_EDIT ? "updateSub" : "saveSub", data: FORM}, (d) => {
      if(!d.error)
      {
      	//console.log(d, this);
      	history.push("/sub");
      	requestAnimationFrame(() => this.getData());
      }
    }, this.props.auth, 1);
	}
	getData(){
		this.setState({
  		data: false
  	});
		api("POST", {"type": "getSubs"}, (d) => {
      if(!d.error)
      {
      	console.log(d);
      	this.setState({
      		data: d.data
      	});
      }
    }, this.props.auth, 1);
	}
	render(){
		const LANG = langs[this.props.lang];
		const USER_INFO = this.state.userData;

    const ACTION_COLORS = ["red", "rgb(199, 199, 8)", "green"];
    const ACTIONS = ["Afventer handling", "Handling igangsat", "Er ordnet"];

		return (<Right title={USER_INFO ? USER_INFO.name : ""}>
							<Panel title={LANG.REPORTS}>
								{
								this.state.ra ?
								<table className="table table-striped jambo_table bulk_action" id="ras">
	            		<thead>
	                  <tr className="headings">
                      <th className="column-title"># </th>
                      <th className="column-title">{LANG.TITLE} </th>
                      <th className="column-title">{LANG.STARTED_DATE} </th>
                      <th className="column-title">{LANG.DONE} </th>
                      <th className="column-title">{LANG.BY} </th>
                      <th className="column-title">{LANG.POINT} </th>
                      <th className="column-title">{LANG.NOTES_AMOUNT} </th>
                      <th className="column-title">{LANG.ADDRESS} </th>
                      <th className="column-title"> </th>
	                  </tr>
	              	</thead>
	                <tbody>
	                	{
	                			this.state.ra.map((d, key) => {
			                    if(d.boundTo)
			                    {
			                      return null;
													}
													console.log(d);
			                    //const sheet = this.state.raSheets.find((sheet) => sheet.id === d.sheetID);
			                		return (<tr key={key} className={key%2 ? "even pointer" : "odd pointer"}>
			                        <td className=" ">{d.id}</td>
			                        <td className=" ">{d.name}</td>
			                        <td className=" ">{parsePHPtime(d.time)}</td>
			                        <td className=" ">
			                        {
			                          d.finished ?
			                            (
			                              d.signDate === 1 ?
			                                parsePHPtime(d.endedTime)
			                              : <i className="fa fa-check"></i>
			                            )
			                          :
			                            <i className="fa fa-times"></i>
			                        }
			                        </td>
			                        <td className=" ">{d.createdBy}</td>
			                        <td className=" ">{d.points}</td>
			                        <td className=" ">{d.commentsAmount}</td>
			                        <td className=" ">{d.address}</td>
			                        <td className=" last">
			                        	<Link to={"/ra/" + d.id}>{LANG['SHOW_REPORT']}</Link> / <a target="_blank" href={"https://safeallday.dk/administration/showReport.php?show=" + d.id + "&lang=DK&hash=" + d.hash}>{LANG["EXTERNAL_REP"]}</a>
			                        </td>
			                    </tr>);
				                })
				              }
	                </tbody>
                </table>
                : <CoolLoader2 show={true} type="table"/>
              }
							</Panel>
							<Panel title={LANG.OBSERVATIONS}>
							{
								this.state.obs ?
									<table className="table table-striped jambo_table bulk_action" id="obs">
	              		<thead>
	                    <tr className="headings">
	                      <th className="column-title"># </th>
                        <th className="column-title">{LANG.TITLE} </th>
                        <th className="column-title">{LANG.STARTED_DATE} </th>
                        <th className="column-title">{LANG.BY} </th>
                        <th className="column-title">{LANG.ADDRESS} </th>
                        <th className="column-title">{LANG.STATUS}</th>
                        <th className="column-title"> </th>
	                    </tr>
	                	</thead>
	                  <tbody>
	                  	{
		                  	this.state.obs.map((d, key) => {
		                      const USR_NAME = d.anon === "1" ? "Anonym" : d.createdBy.name;
		                  		return (<tr key={key} className={key%2 ? "even pointer" : "odd pointer"}>
		                          <td className=" ">{d.id}</td>
		                          <td className=" ">{d.name}</td>
		                          <td className=" ">{parsePHPtime(d.time)}</td>
		                          <td className=" ">
		                            {d.uID && d.anon !== "1" ? <Link to={"/user/" + d.uID}>{USR_NAME}</Link> : USR_NAME}
		                          </td>
		                          <td className=" ">{d.address}</td>
		                          <td className=" " style={{color: ACTION_COLORS[d.status]}}>
		                            <i className="fa fa-circle" aria-hidden="true"></i> {ACTIONS[d.status]}
		                          </td>
		                          <td className=" last">
		                          	<Link to={"/obs/" + d.id}>{LANG.SHOW_OBS}</Link> / <a target="_blank" href={"https://safeallday.dk/administration/showReport.php?show=" + d.id + "&lang=DK&hash=" + d.hash}>{LANG.EXTERNAL_REP}</a> 
		                            {
		                              this.props.rank === -1 || 1 ? <div><Link to="/obs" onClick={() => this.deleteObs(key, d)}>Slet observation</Link></div>: ""
		                            }
		                          </td>
		                      </tr>);
		                  	})
		                  }
	                  </tbody>
	                </table>
								: <CoolLoader2 show={true} type="table"/>
							}
								
						</Panel>
					</Right>);
	}
}

export default UserInfoPage;


// WEBPACK FOOTER //
// ./src/components/UserInfoPage.js